import { Routes } from '@angular/router';
import { authgaurdGuard } from './core/gaurd/authgaurd.guard';
import { dataResolver } from './core/resolver/data.resolver';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'userlogin',
    pathMatch: 'full',
  },
  {
    path: 'userlogin',
    loadComponent: () =>
      import('./components/user-login/user-login.component').then(
        (p) => p.UserLoginComponent
      ),
  },
  {
    path: 'resetpassword',
    loadComponent: () => import('./components/user-login/user-login.component')
      .then(p => p.UserLoginComponent),
  },
  {
    path: 'userhome',
    loadComponent: () =>
      import('./components/user-home/user-home.component').then(
        (p) => p.UserHomeComponent
      ),
    canActivate: [authgaurdGuard],
  },

  {
    path: 'user-profile',
    loadComponent: () =>
      import('./components/user-profile/user-profile.component').then(
        (p) => p.UserProfileComponent
      ),
    canActivate: [authgaurdGuard],
  },

  {
    path: 'admin/company-details',
    loadComponent: () =>
      import(
        './components/admin/company-details/company-details.component'
      ).then((p) => p.CompanyDetailsComponent),
    canActivate: [authgaurdGuard],
  },

  {
    path: 'supplier/manage-supplierfeed',
    loadComponent: () =>
      import(
        './components/supplier/Manage-Supplierfeed/manage-supplierfeed.component'
      ).then((p) => p.ManageSupplierfeedComponent),
    canActivate: [authgaurdGuard],
  },

  {
    path: 'admin/company-branch',
    loadComponent: () =>
      import(
        './components/admin/company-branches/company-branches.component'
      ).then((p) => p.CompanyBranchesComponent),
    canActivate: [authgaurdGuard],
  },

  {
    path: 'admin/manage-roles',
    loadComponent: () =>
      import('./components/admin/company-roles/company-roles.component').then(
        (p) => p.CompanyRolesComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'bookings/ticket-issue',
    loadComponent: () =>
      import('./components/ticket-issue/ticket-issue.component').then(
        (p) => p.TicketIssueComponent
      ),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    path: 'bookings/ticket-issuance-queue',
    loadComponent: () =>
      import('./components/ticket-issuance-queue/ticket-issuance-queue.component').then(
        (p) => p.TicketIssuanceQueueComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/apiout-route-rules',
    loadComponent: () =>
      import('./components/admin/apiout-route-rules/apiout-route-rules.component').then(
        (p) => p.ApiOutRouteRulesComponent
      ),
    canActivate: [authgaurdGuard],
  },
  // Hotel pricing rules (DB 0055-0057: menus + route rows in NSAdmin, else these bounce to home)
  {
    path: 'admin/hotel-supplier-rules',
    loadComponent: () =>
      import('./components/admin/hotel-supplier-rules/hotel-supplier-rules.component').then((p) => p.HotelSupplierRulesComponent),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver },
  },
  {
    path: 'admin/hotel-selling-rules',
    loadComponent: () =>
      import('./components/admin/hotel-selling-rules/hotel-selling-rules.component').then((p) => p.HotelSellingRulesComponent),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver },
  },
  {
    path: 'admin/edit-hotel-pricing-rule',
    loadComponent: () =>
      import('./components/admin/edit-hotel-pricing-rule/edit-hotel-pricing-rule.component').then((p) => p.EditHotelPricingRuleComponent),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver },
  },
  {
    path: 'admin/hotel-pricing-profit',
    loadComponent: () =>
      import('./components/admin/hotel-pricing-profit/hotel-pricing-profit.component').then((p) => p.HotelPricingProfitComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/hotel-location-groups',
    loadComponent: () =>
      import('./components/admin/hotel-location-groups/hotel-location-groups.component').then((p) => p.HotelLocationGroupsComponent),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver },
  },
  {
    path: 'admin/agent-supplier-association',
    loadComponent: () =>
      import(
        './components/admin/agent-supplier-association/agent-supplier-association.component'
      ).then((p) => p.AgentSupplierAssociationComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/branch-supplier-association',
    loadComponent: () =>
      import(
        './components/admin/branch-supplier-association/branch-supplier-association.component'
      ).then((p) => p.BranchSupplierAssociationComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'finance/manage-roe',
    loadComponent: () =>
      import('./components/finance/manage-roe/manage-roe.component').then(
        (p) => p.ManageRoeComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'finance/supplier-ledger',
    loadComponent: () =>
      import('./components/finance/supplier-ledger/supplier-ledger.component').then(
        (p) => p.SupplierLedgerComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'finance/supplier-payments',
    loadComponent: () =>
      import('./components/finance/supplier-payments/supplier-payments.component').then(
        (p) => p.SupplierPaymentsComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'agents/agency-statements',
    loadComponent: () =>
      import(
        './components/agency-statements/agency-statements.component'
      ).then((p) => p.AgencyStatementsComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'reports/flight-ltb-report',
    loadComponent: () =>
      import(
        './components/flight-ltb-report/flight-ltb-report.component'
      ).then((p) => p.FlightLTBReportComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/manage-staff',
    loadComponent: () =>
      import('./components/admin/company-staff/company-staff.component').then(
        (p) => p.CompanyStaffComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/manage-agent',
    loadComponent: () =>
      import('./components/admin/manage-agent/manage-agent.component').then(
        (p) => p.ManageAgentComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/add-agent',
    loadComponent: () =>
      import('./components/admin/add-agent/add-agent.component').then(
        (p) => p.AddAgentComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'supplier/airline-blackout',
    loadComponent: () =>
      import(
        './components/supplier/Airline-Blackout/Airline-Blackout.component'
      ).then((p) => p.AirlineBlackoutComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/hold-configration',
    loadComponent: () =>
      import(
        './components/admin/company-hold-configration/company-hold-configration.component'
      ).then((p) => p.CompanyHoldConfigrationComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/manage-buy-rule',
    loadComponent: () =>
      import(
        './components/admin/manage-buy-rules/manage-buy-rules.component'
      ).then((p) => p.ManageBuyRulesComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/edit-buy-rule',
    loadComponent: () =>
      import('./components/admin/edit-buy-rules/edit-buy-rules.component').then(
        (p) => p.EditBuyRulesComponent
      ),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    path: 'admin/manage-sell-rules',
    loadComponent: () =>
      import(
        './components/admin/manage-sell-rules/manage-sell-rules.component'
      ).then((p) => p.ManageSellRulesComponent),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/edit-sell-rule',
    loadComponent: () =>
      import(
        './components/admin/edit-sell-rules/edit-sell-rules.component'
      ).then((p) => p.EditSellRulesComponent),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    path: 'Bookings',
    loadComponent: () =>
      import('./components/managebookings/managebookings.component').then(
        (p) => p.ManagebookingsComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'directBooking',
    loadComponent: () =>
      import('./components/managebookings/direct-booking/direct-booking.component').then(
        (p) => p.DirectBookingsComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'agency-sales',
    loadComponent: () =>
      import('./components/managebookings/online-agency-sales/online-agency-sales.component').then(
        (p) => p.OnlineAgencySalesComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'direct-booking',
    loadComponent: () =>
      import('./components/managebookings/manual-booking/manual-booking.component').then(
        (p) => p.ManualBookingComponent
      ),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    path: 'edit-booking',
    loadComponent: () =>
      import('./components/managebookings/manual-booking/manual-booking.component').then(
        (p) => p.ManualBookingComponent
      ),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    path: 'cancel-offline-booking',
    loadComponent: () =>
      import('./components/managebookings/cancel-offline-booking/cancel-offline-booking.component').then(
        (p) => p.CancelOfflineBookingComponent
      ),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    // Whole reservation: every product (Booking_Items) - ?pt=<ProductType>&pid=<ProductId> picks the item to open.
    path: 'booking-details/bookingRef/:bookingRef/resid/:resid',
    loadComponent: () =>
      import('./components/managebookings/booking-details/booking-details.component').then(
        (p) => p.BookingDetailsComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/manage-sector-blackout',
    loadComponent: () =>
      import('./components/admin/manage-sector-blackout/manage-sector-blackout.component').then(
        (p) => p.ManageSectorBlackoutComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/manage-ancillary-markup',
    loadComponent: () =>
      import('./components/admin/manage-ancillary-markup/manage-ancillary-markup.component').then(
        (p) => p.ManageAncillaryMarkupComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'admin/manage-config-excel',
    loadComponent: () =>
      import('./components/admin/manage-config-excel/manage-config-excel.component').then(
        (p) => p.ManageConfigExcelComponent
      ),
    canActivate: [authgaurdGuard],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./components/errorpage/errorpage.component').then(
        (p) => p.ErrorpageComponent
      )
  },
  {
    path: 'supplier/manage-supplier',
    loadComponent: () => import('./components/supplier/manage-supplier/manage-supplier.component').then(
      (p) => p.ManageSupplierComponent
    ), canActivate: [authgaurdGuard],
  },
  {
    path: 'supplier/virtual-hold',
    loadComponent: () => import('./components/supplier/virtual-hold/virtual-hold.component').then(
      (p) => p.VirtualHoldComponent
    ), canActivate: [authgaurdGuard],
  },
  {
    path: 'supplier/held-pnr-auto-cancel',
    loadComponent: () => import('./components/supplier/held-pnr-auto-cancel/held-pnr-auto-cancel.component').then(
      (p) => p.HeldPnrAutoCancelComponent
    ), canActivate: [authgaurdGuard],
  },
  {
    path: 'supplier/add-new-supplier',
    loadComponent: () => import('./components/supplier/add-new-supplier/add-new-supplier.component').then(
      (p) => p.AddNewSupplierComponent
    ),
    canActivate: [authgaurdGuard],
    resolve: { initdata: dataResolver }
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/user-login/user-login.component').then(
        (p) => p.UserLoginComponent
      ),
  }
];
